
























































































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions } from "vuex";

import Edit from "@/components/Users/Edit.vue";

const TableHeaders: Header[] = [
  { title: "用户名", key: "", width: 200 },
  { title: "姓名", key: "", width: 200 },
  { title: "邮箱", key: "code", width: 200 },
  { title: "创建时间", key: "", width: 170 },
  { title: "用户角色", key: "", width: 130 },
  { title: "状态", key: "", width: 100 },
  { title: "描述", key: "", width: 100 },
  { title: "锁定时间", key: "", width: 170 },
  { title: "锁定原因", key: "", width: 150 },
  { title: "来源", key: "", width: 100 },
  { title: "添加人", key: "", width: 100 },
  { title: "操作", key: "", width: 80 }
];
export default Vue.extend({
  name: "Users",
  components: { TableLayout, Edit },
  data() {
    return {
      TableHeaders
    };
  },
  computed: {
    ...mapState("Users", [
      "pages",
      "pageNum",
      "total",
      "filterValue",
      "hasNext"
    ]),
    ...mapGetters("Users", ["tableData"])
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions("Users", [
      "getData",
      "delete",
      "search",
      "turnPage",
      "lockUser"
    ]),
    create(data: any) {
      (this.$refs.edit as any)?.show(data);
    },
    del(id: string, name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete(id);
      });
    },
    locked(data: any) {
      this.$confirms({
        title: `${data.locked ? "解锁" : "锁定"} ${data.userName}`,
        message: data.locked
          ? "解除该用户的锁定状态"
          : "锁定该用户后，用户禁止登录系统"
      }).then(() => {
        this.lockUser(data.id).then(() => {
          this.$message.success(`用户已${data.locked ? "解锁" : "锁定"}`);
        });
      });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;
        case "delete":
          this.del(data.id, data.userName);
          break;
        case "locked":
        case "unlocked":
          this.locked(data);
          break;
      }
    }
  }
});
